import { IsInt, IsString } from 'class-validator';

export class SubmitContactInformationDto {
  @IsString()
  postalCode!: string;

  @IsInt()
  provinceId!: number;

  @IsInt()
  cityId!: number;

  @IsString()
  avenue!: string;

  @IsString()
  alley!: string;

  @IsString()
  plaque!: string;

  @IsString()
  phoneNumber!: string;
}
